export default "__VITE_ASSET__D7apE9mg__"